import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface RequestFilterProps {
  sortBy: string;
  onSortChange: (value: string) => void;
  filterStatus: "all" | "read" | "unread";
  onFilterChange: (status: "all" | "read" | "unread") => void;
  statusCounts: {
    all: number;
    read: number;
    unread: number;
  };
}

const SORT_LABELS: Record<string, string> = {
  newest_first: "Newest",
  oldest_first: "Oldest",
  alphabetical_asc: "A-Z",
  alphabetical_desc: "Z-A",
};

export default function RequestFilter({
  sortBy,
  onSortChange,
  filterStatus,
  onFilterChange,
  statusCounts,
}: RequestFilterProps) {
  return (
    <div className="flex min-w-[300px] flex-col gap-3">
      <div className="flex flex-col gap-1">
        <p className="text-sm leading-6 font-bold -tracking-wide">Sort:</p>
        <Select onValueChange={onSortChange} value={sortBy}>
          <SelectTrigger className="text-black-300 bg-admin-input !h-[45px] w-full !px-5 !py-3 text-sm leading-normal font-medium">
            <SelectValue>{SORT_LABELS[sortBy]}</SelectValue>
          </SelectTrigger>
          <SelectContent className="!text-black-300 bg-admin-input">
            <SelectItem value="newest_first" className="!text-black-300">
              Newest
            </SelectItem>
            <SelectItem value="oldest_first" className="!text-black-300">
              Oldest
            </SelectItem>
            <SelectItem value="alphabetical_asc" className="!text-black-300">
              A-Z
            </SelectItem>
            <SelectItem value="alphabetical_desc" className="!text-black-300">
              Z-A
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm leading-6 font-bold -tracking-wide">Filter:</p>
        <button
          onClick={() => onFilterChange("all")}
          className={cn(
            "flex w-full cursor-pointer flex-row justify-between rounded-lg px-5 py-2 text-sm leading-normal font-medium transition-colors hover:bg-white/5",
            filterStatus === "all" && "bg-black-950",
          )}
        >
          <p>All</p>
          <p>{statusCounts.all}</p>
        </button>
        <button
          onClick={() => onFilterChange("unread")}
          className={cn(
            "flex w-full cursor-pointer flex-row justify-between rounded-lg px-5 py-2 text-sm leading-normal font-medium transition-colors hover:bg-white/5",
            filterStatus === "unread" && "bg-black-950",
          )}
        >
          <p>Unread</p>
          <p>{statusCounts.unread}</p>
        </button>
        <button
          onClick={() => onFilterChange("read")}
          className={cn(
            "flex w-full cursor-pointer flex-row justify-between rounded-lg px-5 py-2 text-sm leading-normal font-medium transition-colors hover:bg-white/5",
            filterStatus === "read" && "bg-black-950",
          )}
        >
          <p>Read</p>
          <p>{statusCounts.read}</p>
        </button>
      </div>
    </div>
  );
}
